@if (tableParams$ | async; as tableParams) {
  <div class="content-wrapper">
    @if ($cartridgeVariantName()) {
      <markant-platform-ui-page-header>
        {{
          'cartridge.members.headline'
            | transloco
              : {
                  variantName: $cartridgeVariantName(),
                  totalCount,
                }
        }}
      </markant-platform-ui-page-header>
    } @else {
      <div class="header-spinner">
        <markant-spinner
          type="circle"
          colorScheme="secondary"
        ></markant-spinner>
      </div>
    }

    <div class="toolbar">
      <markant-input
        class="search-field"
        data-cy="input-search-field-cartridge-member"
        data-markant-focus=""
        placeholder="{{ 'cartridge.members.searchPlaceholder' | transloco }}"
        [useCustomLayout]="true"
        [search]="true"
        [debounce]="300"
        [value]="tableParams.searchQuery"
        (valueChange)="onSearchChange($event.detail)"
      >
      </markant-input>
      <markant-platform-filter-menu
        [filter]="filter"
        [preselectedFilter]="tableParams.activeFilter"
        [showFilterChips]="true"
        (filterChanged)="onFilterChange($event)"
      >
      </markant-platform-filter-menu>
    </div>

    <markant-platform-table
      [data]="tableData$ | async"
      [defaultHeaderCells]="tableDraft.headerAndTableCells"
      [loading]="(isLoading$ | async) ?? false"
      [totalCount]="totalCount"
      [pageIndex]="tableParams.page.index"
      [pageSize]="tableParams.page.size"
      (indexChanged)="onIndexChange($event)"
      (pageSizeChanged)="onPageSizeChange($event)"
      (rowClicked)="onRowClick($event)"
    >
    </markant-platform-table>
  </div>
}
